import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29.093} height={32.828} {...props}>
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fillPrimary}}`}</style>
      </defs>
      <g id="prefix__Group_2485" data-name="Group 2485" transform="translate(-227.907 -260.172)">
        <path
          id="prefix__Path_5331"
          data-name="Path 5331"
          className="prefix__cls-1"
          d="M0 18.646a5.235 5.235 0 01.334-.406Q2.4 16.167 4.472 14.1a2.41 2.41 0 01.207-.161c-.182-.173-.337-.311-.483-.458a1.022 1.022 0 010-1.576Q9.96 6.137 15.729.37a1.023 1.023 0 011.577 0q1.256 1.252 2.508 2.508a1.021 1.021 0 010 1.576q-5.767 5.77-11.536 11.537a1.02 1.02 0 01-1.575 0c-.144-.143-.279-.295-.481-.51a1.24 1.24 0 01-.139.233q-2.075 2.076-4.154 4.149c-.119.119-.261.214-.392.321H1.3c-.273-.248-.553-.488-.816-.747-.174-.172-.323-.369-.484-.555z"
          transform="rotate(-109 219.18 59.288)"
        />
        <g id="prefix__Group_2481" data-name="Group 2481" transform="translate(0 78)">
          <rect
            id="prefix__Rectangle_918"
            data-name="Rectangle 918"
            className="prefix__cls-1"
            width={29}
            height={11}
            rx={5.5}
            transform="translate(228 203)"
          />
          <text
            id="prefix__BAT"
            transform="translate(243 212)"
            fill={props.fillSecondary}
            fontSize={10}
            fontFamily="ProximaNova-Bold,Proxima Nova"
            fontWeight={700}>
            <tspan x={-9.325} y={0}>
              {'BAT'}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
